export const AnalyticsEvents = {
  ProjectCreated: 'nfx_Project.created',
  ProjectProcessingStarted: 'nfx_Project.processingStarted',
  ProjectDownloadZip: 'nfx_Project.downloadZip',
  ProjectDownloadSingleFile: 'nfx_Project.downloadSingleFile',
  StudioOpened: 'nfx_Studio.opened',
  StudioModifiedData: 'nfx_Studio.modifiedData',
  UserSignedUp: 'nfx_User.signedUp',
  CheckoutStarted: 'checkout.started',
  PurchaseCompleted: 'purchase',
  StudioDemoOpened: 'nfx_StudioDemo.opened',
  StudioDemoModifiedData: 'nfx_StudioDemo.modifiedData',
} as const;

export const AnalyticsParams = {
  ProjectId: 'nfx_ProjectId',
  ProjectName: 'nfx_ProjectName',
  Runtime: 'nfx_Runtime',
  Services: 'nfx_Services',
  ProjectArchiveType: 'nfx_ProjectArchiveType',
  UploadId: 'nfx_UploadId',
  UploadName: 'nfx_UploadName',
  IsShared: 'nfx_IsShared',
  TransactionId: 'transaction_id',
  PurchaseType: 'nfx_PurchaseType',
  Filename: 'nfx_Filename',
  Value: 'value',
  Currency: 'currency',
} as const;

export const AnalyticsUserProperties = {
  CompanyRole: 'nfx_CompanyRole',
} as const;
